module.exports = __webpack_public_path__ + "img/tj-main-bg.95e095e2.png";